import { render, staticRenderFns } from "./TcCancelAppointment.vue?vue&type=template&id=ff1385d4&"
import script from "./TcCancelAppointment.vue?vue&type=script&lang=js&"
export * from "./TcCancelAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff1385d4')) {
      api.createRecord('ff1385d4', component.options)
    } else {
      api.reload('ff1385d4', component.options)
    }
    module.hot.accept("./TcCancelAppointment.vue?vue&type=template&id=ff1385d4&", function () {
      api.rerender('ff1385d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcCancelAppointment.vue"
export default component.exports